import { Route, Switch } from 'react-router-dom';
import { OrdersAsyncLabelGenerateStatusPage } from './pages/AsyncLabelGenerateStatusPage';
import { OrdersLabelGenerateStatusPage } from './pages/LabelGenerateStatusPage';
import OrdersPrintDocumentsPage from './pages/PrintDocumentsPage/PrintDocumentsPage';
import { NUVEM_ENVIO_ORDERS_ROUTES } from './routes';

function NuvemEnvioOrders(): JSX.Element {
  return (
    <Switch>
      <Route
        exact
        path={NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioPrintLabelStatus}
      >
        <OrdersLabelGenerateStatusPage />
      </Route>
      <Route
        exact
        path={NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioPrintDocuments}
      >
        <OrdersPrintDocumentsPage />
      </Route>
      <Route
        exact
        path={NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioAsyncPrintLabelStatus}
      >
        <OrdersAsyncLabelGenerateStatusPage />
      </Route>
    </Switch>
  );
}

export default NuvemEnvioOrders;
